import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  isMobile = false;
  isChatSelected = false;
  selectedChat: any;
  newMessage: string = '';

  chats = [
    {
      name: 'Nur',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Have a good evening too.',
      time: '8:30 PM',
      unread: 2,
      typing: false,
      messages: [
        { text: 'Hi Nur!', time: '8:25 PM', type: 'left' },
        { text: 'Hi! How are you?', time: '8:26 PM', type: 'right' },
        { text: 'I’m doing well, thanks. Did you get a chance to look at the report?', time: '8:27 PM', type: 'left' },
        { text: 'Yes, I will check it out.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any questions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, I’ll get back to you soon.', time: '8:32 PM', type: 'right' },
        { text: 'Thanks, Nur!', time: '8:33 PM', type: 'left' },
        { text: 'No problem. Have a good evening!', time: '8:35 PM', type: 'right' },
      ]
    },
    {
      name: 'Aisyah',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Amirul',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Minah',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Sol',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Aina',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Ahmad',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
    {
      name: 'Ali',
      avatar: 'assets/images/user-profile.jpg',
      preview: 'Typing...',
      time: '7:15 PM',
      unread: 1,
      typing: true,
      messages: [
        { text: 'Hi Ahmad! How are you?', time: '8:25 PM', type: 'left' },
        { text: 'I am good, Nur. How about you?', time: '8:26 PM', type: 'right' },
        { text: 'I am doing well, thanks for asking!', time: '8:27 PM', type: 'left' },
        { text: 'Did you check out the document I sent earlier?', time: '8:28 PM', type: 'left' },
        { text: 'Yes, I did. It looks good to me.', time: '8:30 PM', type: 'right' },
        { text: 'Great! Let me know if you have any suggestions.', time: '8:31 PM', type: 'left' },
        { text: 'Sure, will do. By the way, are we meeting tomorrow?', time: '8:32 PM', type: 'right' },
        { text: 'Yes, same time as usual?', time: '8:33 PM', type: 'left' },
      ],
    },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkMobileView();
  }

  ngOnInit(): void {
    this.checkMobileView();
  }

  checkMobileView(): void {
    this.isMobile = window.innerWidth <= 767;
  }

  selectChat(chat: any): void {
    this.selectedChat = chat;
    this.isChatSelected = true;
  }

  goBack(): void {
    this.isChatSelected = false;
    this.selectedChat = null;
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      this.selectedChat.messages.push({
        text: this.newMessage,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        type: 'right',
      });
      this.newMessage = '';
    }
  }
}